import { render, staticRenderFns } from "./FavoriteMovie.vue?vue&type=template&id=dd296750&"
import script from "./FavoriteMovie.vue?vue&type=script&lang=js&"
export * from "./FavoriteMovie.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteMovie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports